export default __webpack_public_path__ + "static/media/100x150.dd84e914.jpg";